/**
 * Path: frontend/src/Api/apiConfig.jsx
 */
import axios from "axios";

const API_BASE_URL = import.meta.env.VITE_API_URL || "/api";

const apiClient = axios.create({
  baseURL: API_BASE_URL,
  headers: {
    "Content-Type": "application/json",
  },
  withCredentials: true,
});

/* ----------------------------------------------------
  🔐 INTERCEPTEUR REQUEST : ajoute automatiquement le JWT
  Et gère les envois multipart (FormData)
----------------------------------------------------- */
apiClient.interceptors.request.use((config) => {
  const token =
    localStorage.getItem("authToken") ||
    sessionStorage.getItem("authToken");

  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  // ❗ TRÈS IMPORTANT : Si on envoie du FormData, on laisse le navigateur
  // définir lui-même le Content-Type avec le bon boundary.
  if (config.data instanceof FormData) {
    delete config.headers["Content-Type"];
  }

  return config;
});

/* ----------------------------------------------------
  ❗ INTERCEPTEUR RESPONSE : gère erreurs globales
----------------------------------------------------- */
apiClient.interceptors.response.use(
  (response) => response,

  (error) => {
    if (!error.response) {
      console.error("Erreur réseau :", error);
      return Promise.reject({
        message: "Impossible de contacter le serveur.",
        details: error.message,
      });
    }

    const { status } = error.response;
    const url = error.config?.url || "";

    const safeAuthPaths = [
      "/users/register",
      "/users/check-email",
      "/users/login",
      "/auth/google/callback",
    ];

    const isSafeAuthRoute = safeAuthPaths.some((path) =>
      url.includes(path)
    );

    if (
      status === 401 &&
      window.location.pathname !== "/login" &&
      !isSafeAuthRoute
    ) {
      console.warn("401 détecté → redirection vers /login");
      window.location.href = "/login";
    }

    return Promise.reject(error);
  }
);

export default apiClient;
